import script from "./CollectionEditMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionEditMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./CollectionEditMolecule.css?vue&type=style&index=0&id=2911ca2c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2911ca2c"]])

export default __exports__